import { useCallback, useMemo } from 'react';

import type { FactsheetDetails } from '@/features/factsheet';
import { useFactsheetSelection } from '@/features/factsheet/state/FactsheetSelectionContext';

const useItemsTab = (factsheet: FactsheetDetails) => {
  const selection = useFactsheetSelection();
  const addSymbolsToSelection = selection?.addSymbolsToSelection ?? (() => {});
  const areAllSymbolsSelected = selection?.areAllSymbolsSelected ?? (() => false);
  const removeSymbolsFromSelection = selection?.removeSymbolsFromSelection ?? (() => {});

  const symbols = useMemo(
    () =>
      factsheet.symbols.map(symbol => {
        return {
          Code: factsheet.code,
          Period: symbol.period,
          PeriodType: symbol.periodType,
          TimeRef: symbol.timeRef
        };
      }),
    [factsheet]
  );

  const allItemsSelected = useMemo((): boolean => {
    if (symbols.length < 1) return false;
    return areAllSymbolsSelected(symbols);
  }, [areAllSymbolsSelected, symbols]);

  const clearAllCodesFromSelection = useCallback(() => {
    removeSymbolsFromSelection(symbols);
  }, [removeSymbolsFromSelection, symbols]);

  const addAllCodesToSelection = useCallback(() => {
    addSymbolsToSelection(symbols);
  }, [addSymbolsToSelection, symbols]);

  const handleAllItemsSelection = useCallback(() => {
    if (allItemsSelected) {
      clearAllCodesFromSelection();
    } else {
      addAllCodesToSelection();
    }
  }, [addAllCodesToSelection, allItemsSelected, clearAllCodesFromSelection]);
  return { handleAllItemsSelection, allItemsSelected };
};
export default useItemsTab;
